import React, { useEffect, useRef, useState } from "react";
import { Modal } from "flowbite-react";
import { Icon } from "@iconify/react/dist/iconify.js";
import calender from "../assets/images/calender.svg";

const AddBrouchureModal = ({
  openModal,
  selectedFileName,
  setOpenModal,
  setSelectedFileName,
  ven_name,
  setVen_name,
  date,
  setDate,
  error,
  setError,
  handleUploadpdf,
}) => {
  // ........date..........
  console.log(date, "date from clander....................");

  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);
  const modalRef = useRef();

  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setOpenModal(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      handleOutsideClick(event);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setSelectedFileName(e.dataTransfer.files[0]);
    }
  };
  const onButtonClick = () => {
    inputRef.current.click();
  };

  const handleChange = function (e) {
    e.preventDefault();
    setError({ ...error, Filename: "" });
    if (e.target.files && e.target.files[0]) {
      setSelectedFileName(e.target.files[0]);
    }
  };

  // handleChange for date
  // const handleChangeDate = function (e) {
  //   setError({ ...error, date: "" });
  //   setDate(e.target.value);
  // };

  // Replace handleChangeinput with two separate handlers
  const handleVendorNameChange = (e) => {
    setError({ ...error, venName: "" });
    setVen_name(e.target.value.toLowerCase());
  };

  const handleDateChange = (e) => {
    setError({ ...error, date: "" });
    setDate(e.target.value);
  };

  const handlevalidatepdf = () => {
    const newErrors = {};
    if (!ven_name) {
      newErrors.venName = "Please Enter Vendor Name";
    }
    if (!selectedFileName) {
      newErrors.Filename = "Please Select a File";
    }

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
    } else {
      handleUploadpdf();
    }
  };
  return (
    <Modal
      show={openModal}
      onHide={() => setOpenModal(false)}
      keyboard={false} // Prevents closing on pressing the keyboard Esc key
      className="dashboard-modal-main ring-0  bg-opacity-60 font-userFont"
      ref={modalRef}
      size={"4xl"}
    >
      <Modal.Body className="large2  ">
        <div className="space-y-6  w-full">
          <div className="upload-doc-main  flex justify-between my-4 md:my-7">
            <h1 className=" text-xl md:text-3xl font-semibold text-[#E3D0A8]  mb-3 m-auto">
              Upload Document
            </h1>
            <div
              className="close_btn cursor-pointer"
              onClick={() => {
                setOpenModal(false);
                setSelectedFileName("");
                setVen_name("");
              }}
            >
              <Icon icon="carbon:close-filled" fontSize={25} color="#E3D0A8" />
            </div>
          </div>
          <div className="upload-doc-modal-body flex-column items-center   md:flex-row flex gap-3 md:gap-4 justify-center">
            <form
              id="form-file-upload"
              className="d-flex flex-column setting p-5 justify-center items-center w-[316px] m-auto"
              onDragEnter={handleDrag}
              // onSubmit={(e) => e.preventDefault()}
            >
              <Icon icon="bxs:file-pdf" fontSize={100} color="#E3D0A8" />
              <input
                ref={inputRef}
                type="file"
                id="input-file"
                multiple={true}
                onChange={handleChange}
                className="hidden"
              />
              <label
                id="label-file-upload"
                htmlFor="input-file"
                className={dragActive || selectedFileName ? "drag-active" : ""}
              >
                <div className="flex justify-center align-center ">
                  {selectedFileName ? (
                    <p className="text-ellipsis overflow-hidden ...">
                      {selectedFileName.name}
                    </p>
                  ) : (
                    <p className="">Drag & Drop File to Upload</p>
                  )}
                </div>
              </label>
              {dragActive && (
                <div
                  id="drag-file-element"
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                ></div>
              )}
            </form>

            {selectedFileName ? null : (
              <button
                className="bg-[#E3D0A8] px-4 py-2.5 w-[200px] text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8]"
                onClick={onButtonClick}
              >
                Choose file
              </button>
            )}
            <div className="w-full text-center primary">{error?.Filename}</div>
            <div className="ven-div setting m-auto d-flex p-4 mt-3 w-[364px] ">
              <input
                placeholder="Input Vendor Name"
                type="text"
                className=" venName  text-2xl  m-auto placeholder:!text-[#E3D0A8] text-[#E3D0A8]"
                value={ven_name}
                onChange={handleVendorNameChange}
              />
            </div>

            {/* ---------date clander---------- */}
            <div className=" m-auto p-4 mt-3 w-[364px]  flex items-center gap-2 ">
              <label
                className="flex  text-[#E3D0A8]  justify-center items-center text-2xl cursor-pointer w-full"
                htmlFor="selecDate"
              >
                Choose date:
                {/* <img src={calender} alt="calender" className="h-7 w-7" />{" "} */}
              </label>

              <input
                type="date"
                value={date}
                onChange={handleDateChange}
                id="selecDate"
                className=""
              />
            </div>

            <div className="w-full text-center primary">{error?.venName}</div>
            <button
              className="bg-[#E3D0A8] px-4 py-2.5 w-[200px] text-white hover:bg-white hover:!text-[#E3D0A8] ease-in-out duration-300 hover:!border hover:!border-[#E3D0A8]"
              onClick={() => handlevalidatepdf()}
            >
              Start Analyzing
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddBrouchureModal;
